/**
 * Created with IntelliJ IDEA.
 * User: itaik
 * Date: 4/22/13
 * Time: 10:07 AM
 * To change this template use File | Settings | File Templates.
 */
// <editor-fold desc="AMD Wrapper">
define(function (require) {
    "use strict";

    // <editor-fold desc="Dependencies">
    var _ = require("underscore");
    var $ = require("jquery");
    var Media = require("media");
    var Logger = require("logger");
    var LEResourceResolver = require("leResourceResolver");
    var sessionModel = require("models/SessionModel");
    var appServerSessionModel = require("models/AppServerSessionModel");
    var sessionKeepAlive = require("src/sessionKeepAlive");
    var LEConfig = require("assets/config/le-env-conf");
    var CONST = require("const");
    var Privileges = require("codeTables/privileges.json");

    require("src/jquery.liveEngageSession");
    // </editor-fold desc="Dependencies">

    var SessionManager = (function () {
        /*
         * Public ENUM to control
         * The login commands
         */
        var LOGIN_COMMANDS = {
            LOGIN:"login",
            ACCESSDENIED:"denied"
        };

        var ACCOUNT_SESSION_TYPE = {
            NEW:"new",
            CURRENT:"current",
            EXTERNAL:"external"
        };

        var TOKEN_DEFAULTS = {
            CSRF:{
                header:{
                    key:"X-CSRF-Token",
                    format:"{token}"
                },
                query:{
                    key:"X-CSRF-Token",
                    format:"{token}"
                },
                body:{
                    key:"X-CSRF-Token",
                    format:"{token}"
                }
            },
            GLOB:{
                header:{
                    key:"Authorization",
                    format:"Bearer {token}"
                },
                query:{
                    key:"access_token",
                    format:"{token}"
                },
                body:{
                    key:"access_token",
                    format:"{token}"
                }
            },
            WSUK:{
                header:{
                    key:"X-WSUK-Token",
                    format:"{token}"
                },
                query:{
                    key:"X-WSUK-Token",
                    format:"{token}"
                },
                body:{
                    key:"X-WSUK-Token",
                    format:"{token}"
                }
            }
        };

        var OPTION_KEYS = {
            CSRF:"csrf",
            GLOB:"glob",
            WSUK:"wsuk"
        };

        var validTokenKeys = ["CSRF", "GLOB", "WSUK"];
        var validStatusKeys = ["401", "403"];
        var ver = "0.1";
        var changeHandlers = {};
        var prefilters = {};
        var prefiltersOptions = {};
        var tolerance = {};
        var _external;

        var re = /([^&=]+)=?([^&]*)/g;
        var decodeRE = /\+/g;  // Regex for replacing addition symbol with a space

        // <editor-fold desc="Public Methods">
        function initialize(options) {
            /*jshint validthis:true */
            var context = this;

            if (this.initialized) {
                // Allow Chaining
                return SessionManager;
            }

            options = options || {};
            this.vent = options.vent || Media.channel("SessionManager").vent;
            this.commands = options.commands || Media.channel("SessionManager").commands;
            this.reqres = options.reqres || Media.channel("SessionManager").reqres;
            this.notifier = options.notifier;

            //context logger
            this.logger = Logger.getLogger("LEFramework");

            this.model = sessionModel;
            this.modelAppServer = appServerSessionModel;

            // Listen to a request on the events bus to return the session authentication state
            this.reqres.setHandler("session:isAuthenticated", _.bind(function () {
                return isAuthenticated.call(this);
            }, this));

            // Listen to a command on the events bus to expire and logout
            this.commands.setHandler("session:expire", _.bind(function (options) {
                expire.call(this, options);
            }, this));

            // Listen to a change in the id
            this.onAuthenticationChange("SessionManager", _.bind(function () {
                if (!isAuthenticated.call(this)) {
                    sendLoginCommand.call(this, LOGIN_COMMANDS.LOGIN);
                }
            }, this));

            // Invalid call for save - move back to login
            this.model.on("invalid", _.bind(function (options) {
                expire.call(this);
            }, this));

            // Allows me to register and unregiter prefilters uniquely
            _preparePrefilters(context);

            // For hacking multitab support
            // TODO: Remove when MultiTab support should be enabled
            if ("localStorage" in window && null !== window.localStorage) {
                if ("onstorage" in document) {
                    $(document).on("storage", function (e) {
                        var values = context.model.getLocalStorageFixIE8MissingValues({ clean:true });

                        if (values) {
                            _validateLoginOwnership(context, values);
                        }
                    });
                }
                else {
                    $(window).on("storage", function (e) {
                        _validateLoginOwnership(context, e.originalEvent);
                    });
                }
            }

            $.liveEngageSession("initialize", this);
            sessionKeepAlive.initialize({ sessionManager: this, translator: options.translator, notifier: options.notifier });

            this.initialized = true;

            // Allow Chaining
            return SessionManager;
        }

        function registerTokensAsHeader(options) {
            /*jshint validthis:true */
            _registerPrefilter(this, "headers", options);
        }

        function registerTokensAsParam(options) {
            /*jshint validthis:true */
            _registerPrefilter(this, "param", options);
        }

        function registerStatusCodeHandler(options) {
            /*jshint validthis:true */
            _registerPrefilter(this, "status", options);
        }

        function unregisterTokensAsHeader() {
            /*jshint validthis:true */
            _unregisterPrefilter(this, "headers");
        }

        function unregisterTokensAsParam() {
            /*jshint validthis:true */
            _unregisterPrefilter(this, "param");
        }

        function unregisterStatusCodeHandler() {
            /*jshint validthis:true */
            _unregisterPrefilter(this, "status");
        }

        function sendLoginCommand(command, options) {
            options = options || {};

            // Stop keep alive
            sessionKeepAlive.stop();

            /*jshint validthis:true */
            this.logger.debug("Login navigation command is about to be issued!");
            this.commands.execute("navigate:" + command, options);
        }

        function sendCurrentAccountSwitchCommand(options) {
            options = options || {};

            /*jshint validthis:true */
            var newAccountId = this.model.getCurrentAccountId();
            if (_.isString(newAccountId)) {
                // Stop keep alive
                sessionKeepAlive.stop();
                options.newAccountId = newAccountId;
                this.commands.execute("navigate:switch", options);
                return true;
            }
            else {
                sendLoginCommand.call(this, LOGIN_COMMANDS.LOGIN);
                return false;
            }
        }

        function parseUrlNewAccountIdPlaceHolder() {
            /*jshint validthis: true */
            var accountId = LEResourceResolver.getCurrentAccountId();
            if (ACCOUNT_SESSION_TYPE.CURRENT === accountId) {
                // Please do not remove this since the command will only be executed after the returned value is processed
                // So if there is no "return true/false" the page will be redirected to login or registration instead of the account id switch
                return sendCurrentAccountSwitchCommand.call(this, { accountId: accountId });
            }
            if (accountId === ACCOUNT_SESSION_TYPE.NEW){
                return true;
            }
            if(accountId === ACCOUNT_SESSION_TYPE.EXTERNAL) {
                _external = true;
                return true;
            }

            return false;
        }

        function establish(creds, options) {
            options = options || {};

            var success = options.success;
            var error = options.error;

            /*jshint validthis:true */
            options.success = _.bind(function (model, resp, options) {
                // Do something and than call handler

                // For hacking multitab support
                // Remove All accounts except the account we just logged in to from the correct accounts list
                // TODO: Remove when MultiTab support should be enabled
//                var accountIds = this.model.getCurrentAccountIds();
//                if (accountIds && 1 < accountIds.length) {
//                    var validAccountId = this.getAccountId();
//                    _.each(accountIds, function (accountId, index) {
//                        if (validAccountId !== accountId) {
//                            this.invalidateAccountSession(accountId, true);
//                        }
//                    });
//                }

                this.logger.debug("Session had been establiahed successfuly for account " + model.get(sessionModel.KEY.ACCOUNT_ID));

                // Kick start the keep alive
                this.logger.debug("Kick start the keep alive");
                sessionKeepAlive.start();
                sessionKeepAlive.startAppServerKeepAlive();

                if (success) {
                    success.apply(this, [].slice.apply(arguments));
                }
            }, this);
            options.error = _.bind(function (model, resp, options) {
                this.logger.error("Could not establish session with LE server!!!");
                this.logger.dir(resp);
                this.logger.graph({name:"framework:sessionManager:Could not establish session with LE server"});

                // Do something and than call handler
                if (error) {
                    error.apply(this, [].slice.apply(arguments));
                }

                expire.call(this);
            }, this);

            // Do a POST to /session and send the serialized form creds
            this.model.save(creds, options);

            // Allow Chaining
            return SessionManager;
        }

        function sustain(creds, options) {
            creds = creds || {};
            options = options || {};

            var success = options.success;
            var error = options.error;

            /* // 2 because we have two sessions to sustain - LEServer and AppServer
             // (two async calls to API's that only when completes successfully the success handler should be invoked)
             var renderApp = _.after(2, runMyApp);*/

            /*jshint validthis:true */
            options.success = _.bind(function (model, resp, options) {
                this.logger.debug("Session had been sustained successfully for account " + model.get(sessionModel.KEY.ACCOUNT_ID));

                // Nullify the tolerance
                tolerance = {};

                // Do something and than call handler
                if (success) {
                    success.apply(this, [].slice.apply(arguments));
                }
            }, this);
            options.error = _.bind(function (model, resp, options) {
                var that = this;
                this.logger.error("Could not sustain session with LE server!!!");
                resp = resp || {};
                resp.immediate = true;
                this.logger.dir(resp);

                // Do something and than call handler
                if (error) {
                    error.apply(this, [].slice.apply(arguments));
                }
                // Avoid kicking the user out when there is temporary internet problem
                // I'll work here with blacklist instead of whitelist
                // The blacklist will contain all HTTP codes which require an immediate logout (currently defined to include only 401 & 405)
                // If the returned HTTP code is not in the blacklist, I will check it against the fault tolerance list
                // Result codes from within the fault tolerance list will be accepted (tolerated) only for X occurrences (defined in maxTolerance), after which a logout will be initiated
                // Currently I did not implement a separate retry mechanism and I am using a counter over the basic session keep alive mechanism
                // It seems to be enough for now

                var needToExpire = false;
                if (-1 !== _.indexOf(LEConfig.Session.BlacklistCodes, resp.status)) {
                    needToExpire = true;
                }
                else if (-1 !== _.indexOf(LEConfig.Session.FaultlistCodes, resp.status)) {
                    tolerance[resp.status] = (tolerance[resp.status] ? tolerance[resp.status] + 1 : 1);

                    if (LEConfig.Session.MaxFaultTolerance < tolerance[resp.status]) {
                        needToExpire = true;
                    }
                }

                if (needToExpire) {
                    /*jshint validthis:true */
                    this.logger.error("Session Manager needToExpire because missing cookies, KILLING SESSION: " + resp.status +  " ,fault state: " + JSON.stringify(tolerance || {}), "sessionManager", resp);
                    setTimeout(function(){
                        expire.call(that);
                    }, 100);
                }
                else {
                    this.logger.error("Session Manager got BAD RESPONSE : " + resp.status +  " ,fault state: " + JSON.stringify(tolerance || {}), "sessionManager", resp);
                    this.logger.graph({name:"framework:sessionManager:Session Manager got BAD RESPONSE"});
                }
            }, this);

            creds.accountId = creds.accountId || this.model.get(sessionModel.KEY.ACCOUNT_ID);

            // Do a GET with refresh flag to /session
            this.model.sustain(creds, options);

            // Allow Chaining
            return SessionManager;
        }

        function appServerSustain(creds, options) {
            /*jshint validthis:true */

            creds = creds || {};
            options = options || {};
            var success = options.success;
            var error = options.error;
            this.modelAppServer.fetch({
                success: _.bind(function(model, resp, options) {
                    if (success) {
                        success.apply(this, [].slice.apply(arguments));
                    }
                }, this),
                error: _.bind(function(model, resp, options) {
                    if (error) {
                        error.apply(this, [].slice.apply(arguments));
                    }
                }, this)
            });
        }

        function expire(options) {
            // Do a DELETE to /session and clear the clientside data
            options = options || {};

            var success = options.success;
            var error = options.error;

            /*jshint validthis:true */
            options.success = _.bind(function (model, resp, options) {
                // Now call handler
                if (success) {
                    success.apply(this, [].slice.apply(arguments));
                }

                model.id = void 0;
                model.expire($.extend(true, {}, options, resp));

                if (_.isUndefined(model.previous(sessionModel.KEY.ID))) {
                    sendLoginCommand.call(this, LOGIN_COMMANDS.LOGIN, options);
                }
            }, this);

            options.error = _.bind(function (model, resp, options) {
                if (error) {
                    error.apply(this, [].slice.apply(arguments));
                }

                model.id = void 0;
                model.expire($.extend(true, {}, options, resp));

                if (_.isUndefined(model.previous(sessionModel.KEY.ID))) {
                    sendLoginCommand.call(this, LOGIN_COMMANDS.LOGIN, options);
                }
            }, this);

            // For hacking multitab support
            // TODO: Remove when MultiTab support should be enabled
            if (options.noDestroyForCurrent) {
                options.noDestroy = this.model.hasCurrentAccountId();
            }

            if (this.model.hasValidValue(sessionModel.KEY.ID) && !options.noDestroy) {
                // Destroy the appserver session
                this.modelAppServer.destroy();

                // Destroy the liveengage session
                this.model.destroy(options);
            }
            else {
                options.success(this.model, {}, options);
            }

            // Allow Chaining
            return SessionManager;
        }

        function isAuthenticated(options) {
            options = options || {};

            // Check for existence of a glob to ensure login
            /*jshint validthis:true */
            var authenticated = this.model.isValidSession();

            if (!authenticated && options.force) {
                /*jshint validthis: true */
                this.logger.error("Authentication test failed,  Session Manager KILLING SESSION ,fault state: " + JSON.stringify(tolerance || {}) , "sessionManager", { immediate : true});
                expire.call(this);
            }

            return authenticated;
        }

        function getAuthentication(options) {
            // getAuthentication is wrapped around our router
            // before we start any routers let us see if the user is valid
            /*jshint validthis:true */
            options = options || {};
            var accountId = options[sessionModel.KEY.ACCOUNT_ID] || this.model.get(sessionModel.KEY.ACCOUNT_ID) || "";
            var otk = options[sessionModel.KEY.OTK] || this.model.get(sessionModel.KEY.OTK) || "";
            var persona = options[sessionModel.KEY.PERSONA] || this.model.get(sessionModel.KEY.PERSONA);
            var success = options.success;
            var error = options.error;
            var invalid = options.invalid;

            this.logger.debug("accountId = " + accountId);
            this.logger.debug("otk = " + otk);
            this.logger.debug("persona = " + persona);

            var params = {};
            params[sessionModel.KEY.ACCOUNT_ID] = accountId;
            params[sessionModel.KEY.OTK] = otk;
            params[sessionModel.KEY.PERSONA] = persona;

            return establish.call(this, params, { success:success, error:error, invalid:invalid });
        }

        function offAuthenticationChange(id) {
            var handler = changeHandlers[id];

            if (_.isFunction(handler)) {
                /*jshint validthis:true */
                this.model.off("change:" + sessionModel.KEY.ID, handler);
            }

            // Allow Chaining
            return SessionManager;
        }

        function onAuthenticationChange(id, callback) {
            offAuthenticationChange(id);

            /*jshint validthis:true */
            var handler = _changeHandler(this, callback);

            this.model.on("change:" + sessionModel.KEY.ID, handler);

            // Allow Chaining
            return SessionManager;
        }

        function isInitialized() {
            /*jshint validthis:true */
            return this.initialized;
        }

        function getVent() {
            /*jshint validthis:true */
            return this.vent;
        }

        function getReqRes() {
            /*jshint validthis:true */
            return this.reqres;
        }

        function getCommands() {
            /*jshint validthis:true */
            return this.commands;
        }

        function hasPersona(persona) {
            /*jshint validthis: true */
            if (!isAuthenticated.call(this)) {
                return persona == getDefaultPersona.call(this);
            }

            var config = getConfig.call(this);
            if (!config || !config[sessionModel.KEY.PERSONAS]) {
                return false;
            }

            // Iteration on the array may not be needed :)
            if (config[sessionModel.KEY.DEFAULT_PERSONA] && config[sessionModel.KEY.DEFAULT_PERSONA] == persona) {
                return true;
            }

            return (_.contains(config[sessionModel.KEY.PERSONAS], persona));
        }

        /*
            privilege - numeric: will match the given privilege
                        Array: will match privileges in the given array based on value given in 'or' argument
            or - false: will match all privileges in 'privilege' array (with AND)
                 true: will match at least one privilege in 'privilege' array (with OR)
                 numeric: will match the given privilege OR the given privilege in 'privilege' argument
                 Array: will match all privileges in the given array (with AND) OR the given privilege in 'privilege' argument
        */
        function hasPrivilege(privilege, or) {
            /*jshint validthis: true */
            var config = getConfig.call(this);
            if (!config || !config[sessionModel.KEY.USER_PRIVILEGES] || !privilege) {
                return false;
            }

            if (_.isArray(privilege) && privilege.length) {
                if (_.isArray(or) && or.length) {
                    return (privilege.length === _.intersection(config[sessionModel.KEY.USER_PRIVILEGES], privilege).length) || (or.length === _.intersection(config[sessionModel.KEY.USER_PRIVILEGES], or).length);
                }
                else if (_.isNumber(or)) {
                    return (_.contains(config[sessionModel.KEY.USER_PRIVILEGES], or) || (privilege.length === _.intersection(config[sessionModel.KEY.USER_PRIVILEGES], privilege).length));
                }
                else if (true === or) {
                    return (0 < _.intersection(config[sessionModel.KEY.USER_PRIVILEGES], privilege).length);
                }
                else {
                    return (privilege.length === _.intersection(config[sessionModel.KEY.USER_PRIVILEGES], privilege).length);
                }
            }
            else if (_.isNumber(privilege)) {
                if (_.isArray(or) && or.length) {
                    return (_.contains(config[sessionModel.KEY.USER_PRIVILEGES], privilege) || (privilege.length === _.intersection(config[sessionModel.KEY.USER_PRIVILEGES], or).length));
                }
                else if (_.isNumber(or)) {
                    return (_.contains(config[sessionModel.KEY.USER_PRIVILEGES], privilege) || _.contains(config[sessionModel.KEY.USER_PRIVILEGES], or));
                }
                else {
                    return (_.contains(config[sessionModel.KEY.USER_PRIVILEGES], privilege));
                }
            }

            return false;
        }

        function getDefaultPersona() {
            /*jshint validthis: true */
            var config = getConfig.call(this);
            if (!config || !config[sessionModel.KEY.DEFAULT_PERSONA]) {
                return sessionModel.PERSONA.GUEST;
            }

            return config[sessionModel.KEY.DEFAULT_PERSONA];
        }

        function getActivePersona() {
            /*jshint validthis:true */
            if (!isAuthenticated.call(this)) {
                return getDefaultPersona.call(this);
            }

            var persona = this.model.get(sessionModel.KEY.PERSONA);
            if (_.isUndefined(persona)) {
                return getDefaultPersona.call(this);
            }

            return persona;
        }

        function setActivePersona(persona, options) {
            /*jshint validthis:true */
            options = options || {};
            if (hasPersona.call(this, persona)) {
                this.model.set(sessionModel.KEY.PERSONA, persona, options);
            }

            // Allow Chaining
            return SessionManager;
        }

        function getPersonas() {
            /*jshint validthis: true */
            if (!isAuthenticated.call(this)) {
                return [getDefaultPersona.call(this)];
            }

            var config = getConfig.call(this);
            if (!config || !config[sessionModel.KEY.PERSONAS]) {
                return [];
            }

            return config[sessionModel.KEY.PERSONAS];
        }

        function getPermissionGroupByPrivilege(){
            var permissionGroup = null;
            //in order to get the persona according to the privileges we need to check for those IDs
            if (LE && LE.sessionManager && LE.sessionManager.hasPrivilege) {
                if (LE.sessionManager.hasPrivilege(Privileges.privilegeIDs.LE_VIEW_AGENT_MODULE) && !LE.sessionManager.hasPrivilege([Privileges.privilegeIDs.LE_VIEW_CAMPAIGN_MODULE, Privileges.privilegeIDs.LE_VIEW_USER_MANAGEMENT_MODULE, Privileges.privilegeIDs.LE_VIEW_AGENT_MANAGER_MODULE], true)) {
                    permissionGroup = CONST.PERMISSION_GROUP.AGENT;
                }
                else if (LE.sessionManager.hasPrivilege(Privileges.privilegeIDs.LE_VIEW_AGENT_MANAGER_MODULE) && !LE.sessionManager.hasPrivilege(Privileges.privilegeIDs.LE_VIEW_CAMPAIGN_MODULE)) {
                    permissionGroup = CONST.PERMISSION_GROUP.AGENT_MANAGER;
                }
                else if (LE.sessionManager.hasPrivilege(Privileges.privilegeIDs.LE_VIEW_CAMPAIGN_MODULE) && !LE.sessionManager.hasPrivilege(Privileges.privilegeIDs.LE_VIEW_AGENT_MANAGER_MODULE)) {
                    permissionGroup = CONST.PERMISSION_GROUP.CAMPAIGN_MANAGER;
                }
                else if (LE.sessionManager.hasPrivilege([Privileges.privilegeIDs.LE_VIEW_CAMPAIGN_MODULE, Privileges.privilegeIDs.LE_VIEW_USER_MANAGEMENT_MODULE, Privileges.privilegeIDs.LE_VIEW_AGENT_MANAGER_MODULE])) {
                    permissionGroup = CONST.PERMISSION_GROUP.ADMIN;
                }
                else {
                    permissionGroup = CONST.PERMISSION_GROUP.AGENT;
                }
            }

            return permissionGroup;
        }

       function getPrivileges() {
            /*jshint validthis: true */
            var config = getConfig.call(this);
            if (!config || !config[sessionModel.KEY.USER_PRIVILEGES]) {
                return [];
            }

            return config[sessionModel.KEY.USER_PRIVILEGES];
        }

        function hasExportAcUsersData() {
            if (LE && LE.sessionManager && LE.sessionManager.hasPrivilege) {
                if (LE.sessionManager.hasPrivilege(Privileges.privilegeIDs.EXPORT_AC_USERS_DATA)) {
                    return true;
                }
            }
        }

        function hasViewAcLob() {
            if (LE && LE.sessionManager && LE.sessionManager.hasPrivilege) {
                if (LE.sessionManager.hasPrivilege(Privileges.privilegeIDs.VIEW_AC_LOB)) {
                    return true;
                }
            }
        }

        function hasEditAcLob() {
            if (LE && LE.sessionManager && LE.sessionManager.hasPrivilege) {
                if (LE.sessionManager.hasPrivilege(Privileges.privilegeIDs.EDIT_AC_LOB)) {
                    return true;
                }
            }
        }

        function hasConfigureDefaultSurveyForSkillChange() {
            if (LE && LE.sessionManager && LE.sessionManager.hasPrivilege) {
                if (LE.sessionManager.hasPrivilege(Privileges.privilegeIDs.DEFAULT_SURVEY_FOR_SKILL_CHANGE_CONFIGURATION)) {
                    return true;
                }
            }
        }

        function getFeatures() {
            var key = sessionModel.KEY;

            return sessionModel.get(key.ACCOUNT_DATA + "." + key.PROVISION_DATA +"." + key.FEATURES);
        }

        function getConfig() {
            /*jshint validthis:true */
            if (!isAuthenticated.call(this)) {
                return null;
            }

            return this.model.get(sessionModel.KEY.CONFIG);
        }

        function getGlob() {
            /*jshint validthis:true */
            if (!isAuthenticated.call(this)) {
                return null;
            }

            return this.model.get(sessionModel.KEY.GLOB);
        }

        function getWsuk() {
            /*jshint validthis:true */
            if (!isAuthenticated.call(this)) {
                return null;
            }

            return this.model.get(sessionModel.KEY.WSUK);
        }

        function getCsrf() {
            /*jshint validthis:true */
            if (!isAuthenticated.call(this)) {
                return null;
            }

            return this.model.get(sessionModel.KEY.CSRF);
        }

        function getUserId() {
            /*jshint validthis: true */
            if (!isAuthenticated.call(this)) {
                return null;
            }

            return getConfigProperty.call(this, sessionModel.KEY.USER_ID);
        }

        function getAccountId() {
            /*jshint validthis:true */
            return this.model.get(sessionModel.KEY.ACCOUNT_ID);
        }

        function getFeatureProperty(key) {
            /*jshint validthis: true */
            var features = getFeatures.call(this);

            if (!features){
                return null;
            }

            var feature = _.find(features, { "compoundFeatureID": key });

            return feature;
        }

        function getConfigProperty(key) {
            /*jshint validthis: true */
            var config = getConfig.call(this);
            if (!config || _.isUndefined(config[key])) {
                return null;
            }

            return config[key];
        }

        function getCsdsResponse() {
            /*jshint validthis:true */
            if (!isAuthenticated.call(this)) {
                return null;
            }

            return this.model.get(sessionModel.KEY.CSDS_COLLECTION_RESPONSE);
        }

        function getCsdsResponseProperty(key) {
            /*jshint validthis: true */
            var response = getCsdsResponse.call(this);
            if (!response || !response[key]) {
                return null;
            }

            return response[key];
        }

        function getCsdsServiceURI(key){
            /*jshint validthis:true */
            var csdsResponse = getBaseUris.call(this);
            var requestedObj = _.where(csdsResponse, { 'service': key });

            if(requestedObj.length === 0) {
                return null;
            }
            return requestedObj[0].baseURI;
        }

        function getLoginName() {
            /*jshint validthis: true */
            return getConfigProperty.call(this, sessionModel.KEY.LOGIN_NAME);
        }

        function getServerLoginTime() {
            /*jshint validthis: true */
            return getConfigProperty.call(this, sessionModel.KEY.SERVER_CURRENT_TIME);
        }

        function getServerTimeGMTDiff() {
            /*jshint validthis: true */
            return getConfigProperty.call(this, sessionModel.KEY.SERVER_TIME_GMT_DIFF);
        }

        function getServerAccountOffset() {
            /*jshint validthis: true */
            return getConfigProperty.call(this, sessionModel.KEY.TIME_DIFF);
        }

        function getSSOLogoutUrl() {
            /*jshint validthis: true */
            return getConfigProperty.call(this, sessionModel.KEY.SSO_LOGOUT_URL);
        }

        function getBaseUris() {
            /*jshint validthis: true */
            return getCsdsResponseProperty.call(this, sessionModel.KEY.BASE_URIS);
        }

        function getLastTouched() {
            /*jshint validthis:true */
            if (!isAuthenticated.call(this)) {
                return 0;
            }

            return this.model.getLastTouched();
        }

        function getLogger() {
            /*jshint validthis:true */
            return this.logger;
        }

        function getAccountData() {
            /*jshint validthis:true */
            if (!isAuthenticated.call(this)) {
                return null;
            }
            return this.model.get(sessionModel.KEY.ACCOUNT_DATA);
        }

        function getAccountSettings() {
            /*jshint validthis: true */
            if (!isAuthenticated.call(this)) {
                return null;
            }
            var accountData = getAccountData.call(this);
            if (accountData) {
                var settingsData = accountData[sessionModel.KEY.SETTINGS_DATA];
                if (settingsData) {
                    return settingsData[sessionModel.KEY.SETTINGS];
                }
            }
            return null;
        }

        function getAgentGroupsData() {
            /*jshint validthis: true */
            if (!isAuthenticated.call(this)) {
                return null;
            }
            var accountData = getAccountData.call(this);
            if (accountData) {
                var agentGroupsData = accountData[sessionModel.KEY.AGENT_GROUPS_DATA];
                if (agentGroupsData) {
                    return agentGroupsData;
                }
            }
            return null;
        }

        function getAccountSettingByID(id) {
            /*jshint validthis: true */
            var settings = getAccountSettings.call(this);
            if (id && settings) {
                return _.find(settings, function (val) {
                    return val.id === id;
                });
            }
            return null;
        }

        function getAccountSettingValueByID(id, defaultValue) {
            /*jshint validthis: true */
            var result = getAccountSettingByID.call(this, id);
            if (result) {
                result = result.propertyValue.value;
            }
            else {
                result = defaultValue;
            }
            return result;
        }

        function getBillingData() {
            /*jshint validthis: true */
            var accountData = getAccountData.call(this);
            if (accountData) {
                return accountData[sessionModel.KEY.BILLING_DATA];
            }
            return null;
        }

        function getServerTimeZoneID() {
            /*jshint validthis: true */
            return getConfigProperty.call(this, sessionModel.KEY.SERVER_TIME_ZONE);
        }

        function getSessionLifetime() {
            /*jshint validthis: true */
            return getAccountSettingValueByID.call(this, sessionModel.ACCOUNT_SETTINGS_ID.SESSION_TIMEOUT) || LEConfig.Session.LeServer * 1000;
        }

        function hasLiveEngage2Feature() {
            return sessionModel.hasLiveEngage2Feature();
        }

        function hasCoBrowseFeature() {
            return sessionModel.hasCoBrowseFeature();
        }

        function hasAsyncMessagingFeature() {
            return sessionModel.hasAsyncMessagingFeature();
        }

        function hasWrapUpTimeFeature() {
            return sessionModel.hasWrapUpTimeFeature();
        }
        function hasSLAPerSkillFeature() {
            return sessionModel.hasSLAPerSkillFeature() && sessionModel.hasAsyncMessagingFeature();
        }
        function hasAutoClosePerSkillFeature() {
            return sessionModel.hasAutoClosePerSkillFeature();
        }
        function hasUserTypeBotFeature() {
            return sessionModel.hasUserTypeBotFeature() && sessionModel.hasProfilesFeature();
        }

        function hasConversationSourcesFeature() {
            return sessionModel.hasConversationSourcesFeature();
        }

        function hasMessagingAutoMessagesFeature() {
            return sessionModel.hasMessagingAutoMessagesFeature();
        }

        function hasEditMessagingAutoMessagesFeature() {
            return sessionModel.hasEditMessagingAutoMessagesFeature();
        }

        function hasUnauthMessagingFeature() {
            return sessionModel.hasUnauthMessagingFeature();
        }

        function hasMessagingTransferToAgentFeature() {
            return sessionModel.hasMessagingTransferToAgentFeature();
        }

        function hasGoogleSourceFeature() {
            return sessionModel.hasGoogleSourceFeature();
        }

        function hasLpAuthenticationSupportFeature() {
            return sessionModel.hasLpAuthenticationSupportFeature();
        }

        function hasDataEncryptionDataFeature() {
            return sessionModel.hasDataEncryptionDataFeature();
        }

        function hasMigratingFeature() {
            return sessionModel.hasMigratingFeature();
        }

        function hasAgentGroupsFeature() {
            return sessionModel.hasAgentGroupsFeature();
        }

        function hasVisitorFeedPreFiltering() {
            return sessionModel.hasVisitorFeedPreFiltering();
        }

        function hasBlockAddingUsersFeature() {
            return sessionModel.hasBlockAddingUsersFeature();
        }

        function hasBlockSupportAccessFeature() {
            return sessionModel.hasBlockSupportAccessFeature();
        }

        function hasBlockMSTRAccessFeature() {
            return sessionModel.hasBlockMSTRAccessFeature();
        }

        function hasApiKeyManagementFeature() {
            return sessionModel.hasApiKeyManagementFeature();
        }

        function hasIpRestrictionFeature(){
            return sessionModel.hasIpRestrictionFeature();
        }

        function hasLEMyAccount(){
            return sessionModel.hasLEMyAccount();
        }

        function hasReportBuilderAccessFeature() {
            return sessionModel.hasReportBuilderAccessFeature();
        }

        function hasReportBuilderNonLpaAccessFeature() {
            return sessionModel.hasReportBuilderNonLpaAccessFeature();
        }

        function isSeatBasedFeature(){
            return sessionModel.hasSeatBasedFeature();
        }

        function isUnifiedWindowEnabled() {
            return sessionModel.isUnifiedWindowEnabled();
        }

        function hasLimitStickySizeFeature() {
            return sessionModel.hasLimitStickySizeFeature();
        }

        function hasHotTopicsFeature() {
            return sessionModel.hasHotTopicsFeature();
        }
        function hasAuthenticationChatFeature() {
            return sessionModel.hasAuthenticationChatFeature();
        }
        function hasProfilesFeature() {
            return sessionModel.hasProfilesFeature();
        }
        function hasAuditTrailFeature() {
            return sessionModel.hasAuditTrailFeature();
        }
        function hasMultipleAgentStatesFeature() {
            return sessionModel.hasMultipleAgentStatesFeature();
        }
        function isLPA() {
            return sessionModel.isLPA();
        }

        function isExternal() {
            return !!_external;
        }

        function isAdmin() {
            return sessionModel.isAdmin();
        }

        function hasMultiChatCenterLoadBalancing() {
            return sessionModel.hasMultiChatCenterLoadBalancing();
        }

        function hasMultiChatCenterCascadingLoadBalancing() {
            return sessionModel.hasMultiChatCenterCascadingLoadBalancing();
        }

        function hasLobFeature() {
            return sessionModel.hasLobFeature();
        }

        function hasEntitiesTaggingByLobFeature() {
            /*jshint validthis: true */
            var lobSettings = getAccountSettingValueByID.call(this, sessionModel.ACCOUNT_SETTINGS_ID.LOB_ENABLED);
            return sessionModel.hasEntitiesTaggingByLobFeature() && lobSettings === "true";
        }

        function hasConnectionBarCaseManagementVisible() {
            return sessionModel.hasConnectionBarCaseManagementVisible();
        }

        function hasConnectionBarNotificationVisible() {
            return sessionModel.hasConnectionBarNotificationVisible();
        }

        function hasConnectionBarOpenCaseVisible(){
            return sessionModel.hasConnectionBarOpenCaseVisible(); //TODO
        }

        function hasConnectionBarDisplay() {
            return sessionModel.hasConnectionBarDisplay();
        }

        function hasLpaProfilesAssignmentFeature() {
            return sessionModel.hasLpaProfilesAssignmentFeature();
        }

        function hasRefreshButtonFeature() {
            return sessionModel.hasRefreshButtonFeature();
        }

        function hasLiveChatQueuePriorityFeature() {
            return sessionModel.hasLiveChatQueuePriorityFeature();
        }

        function hasAIAssistWidgetFeature() {
            return sessionModel.hasAIAssistWidgetFeature();
        }

        function hasMessagingFileSharingFeature() {
            /*jshint validthis: true */
            var fileSharingSetting = getAccountSettingValueByID.call(this, sessionModel.ACCOUNT_SETTINGS_ID.MESSAGING_FILE_SHARING_ENABLED);
            return sessionModel.hasAsyncMessagingFeature() && fileSharingSetting === "true";
        }

        function hasMessagingSurveyFeature() {
            return sessionModel.hasMessagingSurveyFeature();
        }

        function hasAutomationAreaFeature() {
            return sessionModel.hasAutomationAreaFeature();
        }

        function hasContentProviderAccountFeature() {
            return sessionModel.hasContentProviderAccountFeature();
        }

        // For hacking multitab support
        // TODO: Remove when MultiTab support should be enabled
//        var invalidateAccountSession = function (accountId, removeFromCurrent) {
//            this.model.invalidateAccountSession(accountId);
//
//            if (removeFromCurrent) {
//                this.model.removeAccountIdFromCurrent(accountId);
//            }
//        };

        function logVersion() {
            /*jshint validthis: true */
            getLogger.call(this).info("sessionManager.js version " + ver);
        }

        function touched() {
            sessionKeepAlive.touched();
        }
        // </editor-fold desc="Public Methods">

        // <editor-fold desc="Private Methods">
        function _decode(str) {
            return decodeURIComponent(str.replace(decodeRE, " "));
        }

        function _parseParams(query) {
            var params = {};
            var elem = re.exec(query);

            while (elem) {
                var key = _decode(elem[1]);
                var val = _decode(elem[2]);
                if ("[]" === key.substring(key.length - 2)) {
                    key = key.substring(0, key.length - 2);
                    (params[key] || (params[key] = [])).push(val);
                }
                else {
                    params[key] = val;
                }

                elem = re.exec(query);
            }

            return params;
        }

        function _changeHandler(context, callback) {
            return function () {
                // Do something and than call handler
                if (callback) {
                    callback.apply(context, [].slice.apply(arguments));
                }
            };
        }

        function _shouldAddTokenValue(model, configOptions, key, type) {
            if (_.isBoolean(configOptions) && !configOptions) {
                return false;
            }
            else if (model.hasAttributeValue(sessionModel.KEY[key])) {
                if (_.isBoolean(configOptions) && configOptions) {
                    return true;
                }
                else {
                    return !_.isUndefined(configOptions) && (
                        (_.isObject(configOptions) && _.isEmpty(configOptions)) ||
                        (_.isBoolean(configOptions.header) && configOptions.header || _.isObject(configOptions.header)) ||
                        (_.isBoolean(configOptions.query) && configOptions.query || _.isObject(configOptions.query)) ||
                        (_.isBoolean(configOptions.body) && configOptions.body || _.isObject(configOptions.body))
                        );
                }
            }
            else {
                return false;
            }
        }

        function _getTokenDefinitions(options, key, type) {
            var definitions = {
                key:TOKEN_DEFAULTS[key][type].key,
                format:TOKEN_DEFAULTS[key][type].format
            };

            var pointer = options[type];
            if (_.isObject(pointer)) {
                if (_.isString(pointer.key)) {
                    definitions.key = pointer.key;
                }
                if (_.isString(pointer.format)) {
                    definitions.format = pointer.format;
                }
            }

            return definitions;
        }

        function _addHeaderToken(model, options, configOptions, jqXHR, key) {
            var definitions = _getTokenDefinitions(configOptions, key, "header");

            jqXHR.setRequestHeader(definitions.key, definitions.format.replace(/{token}/g, model.get(sessionModel.KEY[key])));
        }

        function _addParameterToken(model, options, configOptions, jqXHR, key) {
            options = options || {};
            configOptions = configOptions || {};

            var stringify = false;
            var data = $.ajaxSettings.data || {};
            if (_.isString(options.data) && 0 < options.data.length) {
                try {
                    data = JSON.parse(options.data);
                    stringify = true;
                }
                catch (e) {
                    data = _parseParams(options.data);
                }
            }

            var token = model.get(sessionModel.KEY[key]);
            var booleanValue = _.isBoolean(configOptions) && configOptions;
            var definitions;
            var keyToken;
            if (booleanValue || !_.isUndefined(configOptions) && configOptions.query) {
                definitions = _getTokenDefinitions(configOptions, key, "query");
                keyToken = definitions.key;
                data[keyToken] = data[keyToken] || definitions.format.replace(/{token}/g, token);

                if ("GET" === options.type.toUpperCase() || "DELETE" === options.type.toUpperCase()) {
                    options.data = $.param(data);
                }
                else {
                    var qMark = /\?/;
                    options.url += (qMark.test(options.url) ? "&" : "?") + keyToken + "=" + token;
                }
            }
            if (booleanValue || !_.isUndefined(configOptions) && configOptions.body && "GET" !== options.type.toUpperCase() && "DELETE" !== options.type.toUpperCase()) {
                definitions = _getTokenDefinitions(configOptions, key, "query");
                keyToken = definitions.key;
                data[keyToken] = data[keyToken] || definitions.format.replace(/{token}/g, token);
                options.data = stringify ? JSON.stringify(data) : data;
            }
        }

        function _shouldAddStatusCodeValidation(configOptions) {
            if (_.isBoolean(configOptions) && !configOptions) {
                return false;
            }
            else {
                return !_.isUndefined(configOptions) && (
                    (_.isObject(configOptions) && _.isEmpty(configOptions)) ||
                    (_.isBoolean(configOptions) && configOptions || _.isObject(configOptions) && true === configOptions.logout)
                    );
            }
        }

        function _addStatusCodeValidation(context, options, configOptions, key) {
            if (!_.isUndefined(configOptions)) {
                switch (key) {
                    case "401":
                        if (true === configOptions.logout) {
                            options.statusCode = options.statusCode || $.ajaxSettings.statusCode || {};

                            options.statusCode["401"] = function (jqXHR, textStatus, errorThrown) {
                                // 401 -- Unauthorized
                                sendLoginCommand.call(context, LOGIN_COMMANDS.LOGIN, options);
                            };
                        }
                        else {
                            options.statusCode = options.statusCode || $.ajaxSettings.statusCode || {};

                            options.statusCode["401"] = function (jqXHR, textStatus, errorThrown) {
                                // Lets first validate that the user is unauthorized
                                return context.sustain({ async:false });
                            };
                        }

                        if (_.isUndefined($.ajaxSettings.statusCode) || !_.isFunction($.ajaxSettings.statusCode["401"])) {
                            // Tell jQuery we have a special status code implementation
                            $.ajaxSetup({
                                statusCode:{
                                    401:function () {
                                    }
                                }
                            });
                        }
                        break;
                    case "403":
                        options.statusCode = options.statusCode || $.ajaxSettings.statusCode || {};

                        options.statusCode["403"] = function (jqXHR, textStatus, errorThrown) {
                            // 403 -- Access denied
                            _handleUnAuthorizedError(context, options);
                        };

                        if (_.isUndefined($.ajaxSettings.statusCode) || !_.isFunction($.ajaxSettings.statusCode["403"])) {
                            // Tell jQuery we have a special status code implementation
                            $.ajaxSetup({
                                statusCode:{
                                    403:function () {
                                    }
                                }
                            });
                        }
                        break;
                    default:
                        break;
                }
            }
        }

        function _prepareConfigOptions(key, options, callerOptions) {
            options = options || {};
            callerOptions = callerOptions || {};
            var configOptions;
            var keyOptions = OPTION_KEYS[key] || key;
            var appOptions = _.isBoolean(callerOptions[keyOptions]) && callerOptions[keyOptions] ? {} : callerOptions[keyOptions] || false;

            if (appOptions) {
                configOptions = appOptions;
            }

            var apiOptions = _.isBoolean(options[keyOptions]) && options[keyOptions] ? {} : options[keyOptions];

            if (false === apiOptions) {
                configOptions = void 0;
            }
            else if (_.isObject(apiOptions)) {
                configOptions = $.extend(true, configOptions, apiOptions);
            }

            if (_.isUndefined(configOptions)) {
                return false;
            }

            return configOptions;
        }

        function _createHeaderPrefilter(context, name) {
            return function (options, originalOptions, jqXHR) {
                // If we have a csrf/glob token send it through with the request as an header
                options = options || {};

                var callerOptions = prefiltersOptions[name] || {};

                _.each(validTokenKeys, function (key) {
                    var configOptions = _prepareConfigOptions(key, options.withTokens, callerOptions);
                    if (_shouldAddTokenValue(context.model, configOptions, key, "header")) {
                        _addHeaderToken(context.model, options, configOptions, jqXHR, key);
                    }
                });
            };
        }

        function _createParamPrefilter(context, name) {
            // Hook into jquery
            return function (options, originalOptions, jqXHR) {
                // If we have a csrf/glob token send it through with the next request as a parameter
                options = options || {};

                var callerOptions = prefiltersOptions[name] || {};

                _.each(validTokenKeys, function (key) {
                    var configOptions = _prepareConfigOptions(key, options.withTokens, callerOptions);
                    if (_shouldAddTokenValue(context.model, configOptions, key, "param")) {
                        _addParameterToken(context.model, options, configOptions, jqXHR, key);
                    }
                });
            };
        }

        function _createStatusCodePrefilter(context, name) {
            return function (options, originalOptions, jqXHR) {
                var callerOptions = prefiltersOptions[name] || {};

                _.each(validStatusKeys, function (key) {
                    var configOptions = _prepareConfigOptions(key, options.validateStatus, callerOptions);
                    if (_shouldAddStatusCodeValidation(configOptions)) {
                        _addStatusCodeValidation(context, options, configOptions, key);
                    }
                });
            };
        }

        function _preparePrefilters(context) {
            // Create a callback queue and add it to the prefilters list
            context.preFilters = $.Callbacks("unique");
            $.ajaxPrefilter(context.preFilters.fire);

            // Create the available prefilters
            prefilters.headers = _createHeaderPrefilter(context, "headers");
            prefilters.param = _createParamPrefilter(context, "param");
            prefilters.status = _createStatusCodePrefilter(context, "status");
        }

        function _validateLoginOwnership(context, options) {
            options = options || {};

            var key = options.key;
            var newValue = options.newValue;
            var oldValue = options.oldValue;

            if (sessionModel.KEY.CURRENT_ACCOUNT_ID === key) {
                var currentAccounts = context.model.getCurrentAccountIds();
                var isOwner = context.model.isLastUpdateOwner();
                var lastTouched = context.model.getLastTouched();

                context.logger.debug("oldValue = " + oldValue);
                context.logger.debug("newValue = " + newValue);
                context.logger.debug("isOwner = " + isOwner);
                context.logger.debug("lastTouched = " + lastTouched);
                context.logger.debug("currentAccounts = " + currentAccounts);

                if (!isOwner && 0 < currentAccounts.length) {
                    var accountId = context.getAccountId();
                    var currentHasAccountId = context.model.hasCurrentAccountId({ accountId: accountId });
                    var lastIsAccountId = accountId === context.model.getCurrentAccountId();
                    var noDestroyForCurrent = currentHasAccountId && lastIsAccountId;

                    context.logger.debug("accountId = " + accountId);
                    context.logger.debug("currentHasAccountId = " + currentHasAccountId);
                    context.logger.debug("lastIsAccountId = " + lastIsAccountId);
                    context.logger.debug("noDestroyForCurrent = " + noDestroyForCurrent);

                    if (noDestroyForCurrent) {
                        /*jshint validthis: true */
                        context.logger.error("Another tab is opened with a session to liveengage, this tab will be expired! Session Manager KILLING SESSION ,fault state: " + JSON.stringify(tolerance || {}) , "sessionManager", { immediate : true});
                        setTimeout(function() {
                            context.expire({
                                noDestroyForCurrent: noDestroyForCurrent,
                                errorCode: CONST.AUTH_ERROR.ERROR_LOGIN_DIFFERENT_BROWSER
                            });
                        }, 100);
                    }
                }
            }
        }

        function _registerPrefilter(context, name, options) {
            if (_.isFunction(prefilters[name])) {
                prefiltersOptions[name] = $.extend(true, {}, options);

                context.preFilters.add(prefilters[name]);
            }
        }

        function _unregisterPrefilter(context, name) {
            if (_.isFunction(prefilters[name])) {
                context.preFilters.remove(prefilters[name]);
                delete prefiltersOptions[name];

                // Remove special status code implementation
                delete $.ajaxSettings.statusCode["401"];
                delete $.ajaxSettings.statusCode["403"];
            }
        }

        function _handleUnAuthorizedError(context, options) {
            if (!_.isUndefined(context.notifier)) {
                if (_.isUndefined(context.notification)) {
                    context.notification = context.notifier.showGlobalConfirm({
                        title:context.translator.translate("LEFramework.session.unauthorized.title"),
                        content:context.translator.translate("LEFramework.session.unauthorized.message"),
                        objectAction:{
                            text:context.translator.translate("LEFramework.session.unauthorized.okText"),
                            callback:_.bind(sendLoginCommand, context, LOGIN_COMMANDS.LOGIN, options)
                        }
                    });
                }
            }
            else {
                sendLoginCommand.call(context, LOGIN_COMMANDS.LOGIN, options);
            }
        }
        // </editor-fold desc="Private Methods">

        // <editor-fold desc="Return Area">
        return {
            model:sessionModel,
            initialize:initialize,
            getManager:initialize,
            isInitialized:isInitialized,
            vent:getVent,
            reqres:getReqRes,
            commands:getCommands,
            registerTokensAsHeader:registerTokensAsHeader,
            registerTokensAsParam:registerTokensAsParam,
            registerStatusCodeHandler:registerStatusCodeHandler,
            unregisterTokensAsHeader:unregisterTokensAsHeader,
            unregisterTokensAsParam:unregisterTokensAsParam,
            unregisterStatusCodeHandler:unregisterStatusCodeHandler,
            sendLoginCommand:sendLoginCommand,
            sendCurrentAccountSwitchCommand:sendCurrentAccountSwitchCommand,
            parseUrlNewAccountIdPlaceHolder:parseUrlNewAccountIdPlaceHolder,
            establish:establish,
            sustain:sustain,
            appServerSustain:appServerSustain,
            expire:expire,
            isAuthenticated:isAuthenticated,
            getAuthentication:getAuthentication,
            offAuthenticationChange:offAuthenticationChange,
            onAuthenticationChange:onAuthenticationChange,
            hasPersona:hasPersona,
            hasPrivilege:hasPrivilege,
            getDefaultPersona:getDefaultPersona,
            getActivePersona:getActivePersona,
            setActivePersona:setActivePersona,
            getPersonas:getPersonas,
            getPrivileges:getPrivileges,
            getPermissionGroupByPrivilege:getPermissionGroupByPrivilege,
            getConfig:getConfig,
            getConfigProperty:getConfigProperty,
            getFeatures: getFeatures,
            getFeatureProperty: getFeatureProperty,
            getGlob:getGlob,
            getWsuk:getWsuk,
            getCsrf:getCsrf,
            getUserId:getUserId,
            getAccountId:getAccountId,
            getLoginName:getLoginName,
            getCsdsResponse:getCsdsResponse,
            getCsdsResponseProperty:getCsdsResponseProperty,
            getCsdsServiceURI:getCsdsServiceURI,
            getBaseUris:getBaseUris,
            getLastTouched:getLastTouched,
            getSessionLifetime: getSessionLifetime,
            LOGIN_COMMANDS:LOGIN_COMMANDS,
            KEY:sessionModel.KEY,
            ACCOUNT_SETTINGS_ID:sessionModel.ACCOUNT_SETTINGS_ID,
            PERSONA:sessionModel.PERSONA,
            ACCOUNT_SESSION_TYPE:ACCOUNT_SESSION_TYPE,
            PRIVILEGES: Privileges.privilegeIDs,
            version:logVersion,
            // Delegate sessionKeepAlive.touched method
            touched:touched, //,
            // For hacking multitab support
            // TODO: Remove when MultiTab support should be enabled
//            invalidateAccountSession:invalidateAccountSession
            getAccountSettingByID:getAccountSettingByID,
            getAgentGroupsData:getAgentGroupsData,
            getAccountSettingValueByID:getAccountSettingValueByID,
            getServerLoginTime:getServerLoginTime,
            getServerTimeGMTDiff:getServerTimeGMTDiff,
            getServerAccountOffset:getServerAccountOffset,
            getSSOLogoutUrl:getSSOLogoutUrl,
            getBillingData:getBillingData,
            getServerTimeZoneID:getServerTimeZoneID,
            hasLiveEngage2Feature:hasLiveEngage2Feature,
            hasDataEncryptionDataFeature:hasDataEncryptionDataFeature,
            hasMigratingFeature:hasMigratingFeature,
            hasAsyncMessagingFeature:hasAsyncMessagingFeature,
            hasSLAPerSkillFeature:hasSLAPerSkillFeature,
            hasAutoClosePerSkillFeature: hasAutoClosePerSkillFeature,
            hasWrapUpTimeFeature: hasWrapUpTimeFeature,
            hasUserTypeBotFeature:hasUserTypeBotFeature,
            hasConversationSourcesFeature:hasConversationSourcesFeature,
            hasMessagingAutoMessagesFeature:hasMessagingAutoMessagesFeature,
            hasEditMessagingAutoMessagesFeature:hasEditMessagingAutoMessagesFeature,
            hasUnauthMessagingFeature:hasUnauthMessagingFeature,
            hasGoogleSourceFeature:hasGoogleSourceFeature,
            hasLpAuthenticationSupportFeature:hasLpAuthenticationSupportFeature,
            hasAgentGroupsFeature:hasAgentGroupsFeature,
            hasVisitorFeedPreFiltering:hasVisitorFeedPreFiltering,
            hasBlockAddingUsersFeature: hasBlockAddingUsersFeature,
            hasBlockSupportAccessFeature: hasBlockSupportAccessFeature,
            hasBlockMSTRAccessFeature: hasBlockMSTRAccessFeature,
            hasApiKeyManagementFeature: hasApiKeyManagementFeature,
            hasIpRestrictionFeature: hasIpRestrictionFeature,
            hasLEMyAccount: hasLEMyAccount,
            hasReportBuilderAccessFeature: hasReportBuilderAccessFeature,
            hasReportBuilderNonLpaAccessFeature: hasReportBuilderNonLpaAccessFeature,
            isSeatBasedFeature: isSeatBasedFeature,
            isUnifiedWindowEnabled: isUnifiedWindowEnabled,
            hasLimitStickySizeFeature: hasLimitStickySizeFeature,
            hasHotTopicsFeature: hasHotTopicsFeature,
            hasAuthenticationChatFeature: hasAuthenticationChatFeature,
            hasExportAcUsersData: hasExportAcUsersData,
            hasViewAcLob: hasViewAcLob,
            hasEditAcLob: hasEditAcLob,
            hasConfigureDefaultSurveyForSkillChange: hasConfigureDefaultSurveyForSkillChange,
            isLPA: isLPA,
            isExternal:isExternal,
            isAdmin: isAdmin,
            hasMultiChatCenterLoadBalancing: hasMultiChatCenterLoadBalancing,
            hasCoBrowseFeature: hasCoBrowseFeature,
            hasAIAssistWidgetFeature: hasAIAssistWidgetFeature,
            hasMultiChatCenterCascadingLoadBalancing: hasMultiChatCenterCascadingLoadBalancing,
            hasProfilesFeature: hasProfilesFeature,
            hasLobFeature: hasLobFeature,
            hasEntitiesTaggingByLobFeature: hasEntitiesTaggingByLobFeature,
            hasConnectionBarCaseManagementVisible: hasConnectionBarCaseManagementVisible,
            hasConnectionBarDisplay: hasConnectionBarDisplay,
            hasConnectionBarOpenCaseVisible: hasConnectionBarOpenCaseVisible,//TODO
            hasConnectionBarNotificationVisible: hasConnectionBarNotificationVisible,
            hasLpaProfilesAssignmentFeature: hasLpaProfilesAssignmentFeature,
            hasAuditTrailFeature: hasAuditTrailFeature,
            hasMultipleAgentStatesFeature: hasMultipleAgentStatesFeature,
            hasRefreshButtonFeature: hasRefreshButtonFeature,
            hasLiveChatQueuePriorityFeature: hasLiveChatQueuePriorityFeature,
            hasMessagingFileSharingFeature: hasMessagingFileSharingFeature,
            hasMessagingTransferToAgentFeature: hasMessagingTransferToAgentFeature,
            hasContentProviderAccountFeature: hasContentProviderAccountFeature,
            hasAutomationAreaFeature: hasAutomationAreaFeature,
            hasMessagingSurveyFeature: hasMessagingSurveyFeature
        };
        // </editor-fold desc="Private Methods">
    })();

    return SessionManager;
});
// </editor-fold desc="AMD Wrapper">
